import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import RadioGroup from '../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { saloon1ImageOptions } from './views/saloon1'

class X40Interior extends Component {
    constructor(props) {
        super(props);
        this.handleFloorboardChange = this.handleFloorboardChange.bind(this);
        this.handleHandrailChange = this.handleHandrailChange.bind(this);
        this.handleVeneerChange = this.handleVeneerChange.bind(this);
    }

    handleVeneerChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Veneer = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleFloorboardChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Floorboard = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleHandrailChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Handrail = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = saloon1ImageOptions;

        let image = <ConfiguratorImage boat="X4_0" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Saloon' /></h1>
                    <h2><Trans defaults='Surfaces' /></h2>

                    <h3><b><Trans defaults='Veneer for furniture and bulkheads' /></b></h3>

                    <MaterialSelector label={this.props.configuration.Veneer.label} options={this.props.veneerOptions} value={this.props.configuration.Veneer} onChange={this.handleVeneerChange} />

                    <h3><Trans defaults='Laminate for floorboards' /></h3>

                    <MaterialSelector label={this.props.configuration.Floorboard.label} options={this.props.floorboardOptions} value={this.props.configuration.Floorboard} onChange={this.handleFloorboardChange} />

                    <h3><b><Trans defaults='Handrails' /></b></h3>

                    <RadioGroup label={this.props.configuration.Handrail.label} options={this.props.handrailOptions} value={this.props.configuration.Handrail} onChange={this.handleHandrailChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X40Interior);


// WEBPACK FOOTER //
// ./src/X40/X40Interior.js